module.exports = __webpack_public_path__ + "img/bureuIconSample.87930b64.svg";